import {
  GET_MOORING_LINE_USED,
  CREATE_MOORING_LINE_USED,
  EDIT_MOORING_LINE_USED,
  DELETE_MOORING_LINE_USED,
  MOORING_LINE_USED_ERROR,
  SHOW_MOORING_LINE_USED_LOADING,
  SHOW_EDIT_MOORING_LINE_USED_LOADING,
} from '../actions/types';

/**
 * aldrine-facistol-sc-1165: Logbook - Add dropdown for 2 fields
 */

const initialState = {
  mooringLineUsedList: [],
  mooringLineUsedLoading: false,
  editMooringLineUsedLoading: false,
  error: {},
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SHOW_MOORING_LINE_USED_LOADING:
      return {
        ...state,
        mooringLineUsedLoading: true,
      };
    case SHOW_EDIT_MOORING_LINE_USED_LOADING:
      return {
        ...state,
        editMooringLineUsedLoading: true,
      };
    case GET_MOORING_LINE_USED:
      return {
        ...state,
        mooringLineUsedList: payload,
        mooringLineUsedLoading: false,
      };
    case CREATE_MOORING_LINE_USED:
      return {
        ...state,
        mooringLineUsedList: [payload, ...state.mooringLineUsedList],
        editMooringLineUsedLoading: false,
        mooringLineUsedLoading: false,
      };
    case EDIT_MOORING_LINE_USED:
      return {
        ...state,
        mooringLineUsedList: state.mooringLineUsedList.map((item) =>
          item._id === payload._id ? payload : item
        ),
        editMooringLineUsedLoading: false,
        mooringLineUsedLoading: false,
      };
    case DELETE_MOORING_LINE_USED:
      return {
        ...state,
        mooringLineUsedList: state.mooringLineUsedList.filter(
          (item) => item._id !== payload
        ),
        editMooringLineUsedLoading: false,
        mooringLineUsedLoading: false,
      };
    case MOORING_LINE_USED_ERROR:
      return {
        ...state,
        error: payload,
        mooringLineUsedLoading: false,
        editMooringLineUsedLoading: false,
      };
    default:
      return state;
  }
}
